import ItiButton from "@/iti-core-react/components/ItiButton/ItiButton";
import ItiPopUpComponent from "@/iti-core-react/components/ItiPopUp/ItiPopUp";
import ItiTextBoxComponent from "@/iti-core-react/components/ItiTextBox/ItiTextBox";
import { useLanguage } from "@/iti-core-react/hooks/useLanguage";
import { ItiMessageService } from "@/iti-core-react/services/iti-message-service";
import BaseForm from "@/pages/Base/BaseForm/BaseForm";
import { UserService } from "@/shared/services/userService";
import { useScreenSize } from "@/utils/media-query";
import ValidationGroup from "devextreme-react/cjs/validation-group";
import { useState } from "react";
import { getRequiredEmail, imgSrcLogoITI } from "../LoginForm.utils";
import "./CardRecoveryPassword.scss";

interface CardRecoveryPasswordProps {
	finishPasswordRecovery: () => void;
}

export default function CardRecoveryPassword({
	finishPasswordRecovery,
}: Readonly<CardRecoveryPasswordProps>) {
	const { t } = useLanguage();
	const requiredEmail = getRequiredEmail(t);
	const [credentials, setCredentials] = useState<{
		userName: string;
		password: string;
		email: string;
	}>({ userName: "", password: "", email: "" });
	const { isXSmallVertical, isSmallHorizontal } = useScreenSize();

	function onSubmit(e: any) {
		e?.preventDefault?.();
		submitRecoveryPassword(e);
	}

	function submitRecoveryPassword(e: any) {
		try {
			if (e?.validationGroup?.validate()?.isValid) {
				UserService.restorePassword(credentials.email).then(() => {
					ItiMessageService.toastSuccess("login.passwordrecovery-success");
					setCredentials((prev: any) => ({
						...prev,
						email: "",
					}));
					finishPasswordRecovery();
				});
			}
		} catch (error) {
			ItiMessageService.toastError((error as Error).message);
		}
	}

	function getWidthPopup() {
		if (isXSmallVertical) {
			return "95%";
		}
		if (isSmallHorizontal) {
			return "50%";
		}
		return "456px";
	}

	function getHeightPopup() {
		if (isXSmallVertical) {
			return "55%";
		}
		if (isSmallHorizontal) {
			return "90%";
		}
		return "540px";
	}

	return (
		<ItiPopUpComponent
			title={t("login.passwordrecovery-title")}
			visible={true}
			width={getWidthPopup()}
			height={getHeightPopup()}
			onHide={() => {
				finishPasswordRecovery();
			}}
		>
			<BaseForm
				card={false}
				showCancel={false}
				showSubmit={false}
				isPopup={true}
			>
				<ValidationGroup>
					<div>
						<div className={"password-recovery-text"}>
							{t("login.passwordrecovery-text")}
						</div>

						<div className="row">
							<div className="col-12">
								<ItiTextBoxComponent
									label={t("login.email")}
									value={credentials.email}
									onValueChanged={(e: any) =>
										setCredentials((prev: any) => ({
											...prev,
											email: e.value,
										}))
									}
									validationRules={requiredEmail}
								/>
							</div>
							<div className="col-12 mt-4">
								<ItiButton
									text={t("login.passwordrecovery")}
									onClick={onSubmit}
									stylingMode="contained"
									type="default"
									className="password-recovery-button"
								/>
							</div>
						</div>

						<div className="col-12 login-form-logo-container password-recovery-form-logo-container">
							<div className="login-form-logo-text">Powered by</div>
							<div>
								<img
									className="login-form-logo"
									src={imgSrcLogoITI}
									alt="ITI"
								/>
							</div>
						</div>
					</div>
				</ValidationGroup>
			</BaseForm>
		</ItiPopUpComponent>
	);
}
